import {$} from '../jquery-definition.js';

$( function() {
	$( 'form' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.find( '.g-recaptcha' ).addClass( 'active' );
	} );
} );
